export function isValidPhoneNumber(phone_number) {
  const regex = new RegExp("^[1-9]{1}[0-9]{8}$");

  if (regex.test(phone_number)) {
    return true;
  }
  return false;
}
